module.exports = __webpack_public_path__ + "static/media/YM16_4.68ec7718.jpg";